export default {
    compareDisplayOrder(a, b) {
        if (a.displayOrder < b.displayOrder)
          return -1;
        if (a.displayOrder > b.displayOrder)
          return 1;
        return 0;
      },
      compareDate(a, b) {
        if (a.date < b.date)
          return 1;
        if (a.date > b.date)
          return -1;
        return 0;
      },
      compareIsCompleted(a, b) {
        if(a.isCompleted && !b.isCompleted) {
          return 1;
        }
        if(!a.isCompleted && b.isCompleted) {
          return -1;
        }
        return 0;
      }
}